export const gtag: Gtag.Gtag = function () {
  if (!Array.isArray(window.dataLayer)) {
    return;
  }
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
};
